import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import "./CustomModal.css"
function CustomModal(props) {
  return (
    <Modal       {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {/* <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Using Grid in Modal
        </Modal.Title>
      </Modal.Header> */}
      <Modal.Body className="grid-example text-center mt-4">
<strong>      هل تريد حذف هذا  {props?.ar_status} ؟
</strong>
      </Modal.Body>
      <Modal.Footer className='border-0 d-flex justify-content-center align-items-center'>
        <Button onClick={props.deleteItem}>مسح</Button>
        <Button variant='danger' onClick={props.onHide}>أغلاق</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CustomModal
